import React, { useMemo } from "react";

import { Order } from "../../../../../../../services";
import { OrderSource } from "../../../../../../../types";
import { CellContentRoot } from "..";

const SourceCallSingCellContent: React.FC<SourceCallSingCellContent.Props> = ({
	item,
}) => {
	const content = useMemo(
		() => item.additionalFields?.initiator?.callSign ?? "",
		[item.additionalFields?.initiator?.callSign],
	);

	const backgroundColor = useMemo(() => {
		if (typeof item.source !== "string") return undefined;

		const [colorOrange, colorGreen] = ["#ffa940", "#73d13d"];

		const colorMap = {
			[OrderSource.DISPATCHER]: colorGreen,
			[OrderSource.EXECUTOR]: colorOrange,
		};

		return colorMap[item.source] || undefined;
	}, [item.source]);

	return (
		<CellContentRoot
			alignItems="center"
			backgroundColor={backgroundColor}
			h="100%"
			w="100%"
		>
			{content}
		</CellContentRoot>
	);
};

declare namespace SourceCallSingCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default SourceCallSingCellContent;
